import type { ChannelDefinition } from '../types';

const channelNameCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export function compareChannelsByName(left: ChannelDefinition, right: ChannelDefinition): number {
  return (
    channelNameCollator.compare(left.displayName, right.displayName) ||
    left.sourceColumnIndex - right.sourceColumnIndex
  );
}

export function sortChannelsByName(channels: ChannelDefinition[]): ChannelDefinition[] {
  return [...channels].sort(compareChannelsByName);
}
